import { useMutation, MutationTuple } from '@apollo/client';
// Api
import { SET_CB_SETTING } from 'api/cbSettings/mutations';
// Types
import {
  SetCbSetting,
  SetCbSettingVariables,
} from 'api/cbSettings/types/SetCbSetting';

export const useSetCbSetting = (): MutationTuple<
  SetCbSetting,
  SetCbSettingVariables
> => {
  return useMutation<SetCbSetting, SetCbSettingVariables>(SET_CB_SETTING);
};
